class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (typeof Ajaxinate !== 'undefined') {
    new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: '',
      callback: function () {
        applyOutOfStockVisibility();
      }
    });
      let toggleSwitch = document.querySelector('#switcher_stock');
      function applyOutOfStockVisibility() {
        const oosProducts = document.querySelectorAll('li.out-of-stock-pro');
        if (toggleSwitch && toggleSwitch.checked) {
          oosProducts.forEach(item => item.classList.add('hidden'));
        } else {
          oosProducts.forEach(item => item.classList.remove('hidden'));
        }
      }
    }    
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
    console.log("1111");
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    // 1111
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    try {
if (typeof iWish !== "undefined") {
 setTimeout(function(){
iWish.checkIwishColl();
iWishQV.init();
},1500);
}
} catch (error) {
// console.log(error);
}

    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: 'Showing 20 out of 52 products',
    });

  // const toggleSwitch = document.querySelector('#switcher_stock');
  // const oosProducts = document.querySelectorAll('li.out-of-stock-pro');
  
  // if (toggleSwitch && toggleSwitch.checked) {
  //   // Hide out-of-stock (add hidden class)
  //   oosProducts.forEach(item => item.classList.add('hidden'));
  // } else {
  //   // Show out-of-stock (remove hidden class)
  //   oosProducts.forEach(item => item.classList.remove('hidden'));
  // }




    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    try {
      if (typeof iWish !== "undefined") {
      setTimeout(function(){
      iWish.checkIwishColl();
      iWishQV.init();
      },1500);
      }
      } catch (error) {
      // console.log(error);
      }
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


document.addEventListener('click', function (event) {
  const clearBtn = event.target.closest('.clear_filters');
  if (clearBtn) {
    clearBtn.style.display = 'none';
    document.querySelectorAll('.active-facets__button-remove').forEach(button => {
      button.click();
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  // ---------- 1) CUSTOM SORT (no manual fetch!) ----------
  document.addEventListener("click", function (event) {
    const clicked = event.target.closest(".custom-sort-option");
    if (!clicked) return;

    document.querySelectorAll(".custom-sort-option").forEach(el => el.classList.remove("active"));
    clicked.classList.add("active");

    const sortValue = clicked.dataset.value;
    const filterForm = document.querySelector("facet-filters-form form");
    const sortField = filterForm && filterForm.querySelector("[name='sort_by']");

    if (filterForm && sortField) {
      sortField.value = sortValue;
      filterForm.dispatchEvent(new Event("input", { bubbles: true }));
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortValue);
      window.location.href = url.toString();
    }
  });

  // Toggle custom sort dropdown
  document.addEventListener("click", function (event) {
    const sortByLabel = event.target.closest(".sort_by_label");
    const sortDiv = document.querySelector(".sort_by_div");
    const sortList = document.querySelector(".custom-sort-list");

    if (sortByLabel && sortList && sortDiv) {
      event.stopPropagation();
      const isOpen = sortList.classList.toggle("open");
      sortDiv.classList.toggle("active", isOpen);
    } else {
      const label = document.querySelector(".sort_by_label");
      const list = document.querySelector(".custom-sort-list");
      const div = document.querySelector(".sort_by_div");
      if (label && list && div && !label.contains(event.target) && !list.contains(event.target)) {
        list.classList.remove("open");
        div.classList.remove("active");
      }
    }
  });

  // ---------- 2) IN-STOCK TOGGLE BINDING + HIDE OUT-OF-STOCK ----------
  function bindToggle() {
    const toggleSwitch = document.querySelector("#switcher_stock");
    const instockFilter = document.querySelector(".instock-cst input[type='checkbox']");
    if (!toggleSwitch || !instockFilter) return;

    // Prevent duplicate listeners
    if (!toggleSwitch.dataset.bound) {
      toggleSwitch.addEventListener("change", function () {
        if (toggleSwitch.checked !== instockFilter.checked) instockFilter.click();
        handleOutOfStockVisibility(toggleSwitch.checked);
      });
      toggleSwitch.dataset.bound = "1";
    }

    if (!instockFilter.dataset.bound) {
      instockFilter.addEventListener("change", function () {
        toggleSwitch.checked = instockFilter.checked;
        toggleSwitch.toggleAttribute("checked", instockFilter.checked);
        handleOutOfStockVisibility(toggleSwitch.checked);
      });
      instockFilter.dataset.bound = "1";
    }

    // Initial sync
    toggleSwitch.checked = instockFilter.checked;
    toggleSwitch.toggleAttribute("checked", instockFilter.checked);

    // Apply initial visibility
    handleOutOfStockVisibility(toggleSwitch.checked);
  }

  // Function to hide/show out-of-stock products
  function handleOutOfStockVisibility(hide) {
    const outOfStockProducts = document.querySelectorAll(".out-of-stock-pro");
    outOfStockProducts.forEach(el => {
      if (hide) {
        el.classList.add("hidden");
      } else {
        el.classList.remove("hidden");
      }
    });
  }

  // Initial bind
  bindToggle();

  // Observe filter DOM for changes
  const filterContainer = document.getElementById("FacetFiltersForm");
  if (filterContainer) {
    const mo = new MutationObserver(() => {
      clearTimeout(mo._debounce);
      mo._debounce = setTimeout(bindToggle, 120);
    });
    mo.observe(filterContainer, { childList: true, subtree: true });
  }

  // Patch Shopify's renderFilters
  if (window.FacetFiltersForm && typeof FacetFiltersForm.renderFilters === "function") {
    const originalRenderFilters = FacetFiltersForm.renderFilters.bind(FacetFiltersForm);
    FacetFiltersForm.renderFilters = function (...args) {
      const result = originalRenderFilters(...args);
      setTimeout(bindToggle, 50);
      return result;
    };
  }

  // Ajaxinate pagination support
  document.addEventListener("ajaxinate:load", function () {
    setTimeout(bindToggle, 50);
  });
});

// HIDE PRODUCTS SOLD-OUT

// const toggleSwitch = document.querySelector('#switcher_stock');

function applyOutOfStockVisibility() {
  const oosProducts = document.querySelectorAll('li.out-of-stock-pro');
  
  if (toggleSwitch && toggleSwitch.checked) {
    // Hide out-of-stock (add hidden class)
    oosProducts.forEach(item => item.classList.add('hidden'));
  } else {
    // Show out-of-stock (remove hidden class)
    oosProducts.forEach(item => item.classList.remove('hidden'));
  }
}

// ✅ Run on page load
document.addEventListener('DOMContentLoaded', applyOutOfStockVisibility);

// ✅ Run when toggle changes
if (toggleSwitch) {
  toggleSwitch.addEventListener('change', applyOutOfStockVisibility);
}

// ✅ Run after Shopify Facets/AJAX updates
document.addEventListener('shopify:section:load', applyOutOfStockVisibility);
document.addEventListener('facets:updated', applyOutOfStockVisibility);

// ✅ Run after infinite scroll (Ajaxinate)
document.addEventListener('ajaxinate:load', applyOutOfStockVisibility);










